<template>
    <div class="row">
        <div class="col-12 col-lg-7">
            <ibox :title="title_edit">
                <template slot="content" slot-scope="{ setLoading }">
                    <Form slot="content" @loading="setLoading"></Form>
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
    import Ibox from '@/components/Ibox'
    import Form from '@/components/VNFR/Categories/Form'

    export default {
        name: 'BaseAdd',
        data() {
            return {
                title_edit: 'Kategoria'
            }
        },
        components: {
            Ibox,
            Form
        }
    }
</script>
